
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/precos",
      function () {
        return require("private-next-pages/precos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/precos"])
      });
    }
  